import { createContext, useContext, useState, useCallback } from "react";

export const ControlDebugContext = createContext();
ControlDebugContext.displayName = "ControlDebug";
export const useControlDebug = () => useContext(ControlDebugContext);

const ControlDebugProvider = ({ children }) => {
    const [debugSections, setDebugSections] = useState({});

    const setDebugSection = useCallback((sectionName, data) => {
        setDebugSections(prev => ({
            ...prev,
            [sectionName]: data
        }));
    }, []);

    return (
        <ControlDebugContext.Provider value={{ debugSections, setDebugSection }}>
            {children}
        </ControlDebugContext.Provider>
    );
};

export default ControlDebugProvider;
